import { render, staticRenderFns } from "./BranchDistrict.vue?vue&type=template&id=6eecf88c&"
import script from "./BranchDistrict.vue?vue&type=script&lang=js&"
export * from "./BranchDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports